// src/components/partial-pages/VoicePage/VoiceDevicesModal/helpers.ts

import type { Device } from './types'
import { LANGUAGE_LABEL_BY_CODE } from 'lib/types/languages'

export function languageLabel(lang?: string): string {
  const code = String(lang || '').trim()
  if (!code) return ''
  return LANGUAGE_LABEL_BY_CODE[code] || code
}

export function toLangLabelFromDeviceGroup(code?: string): string {
  return languageLabel(code)
}

export function deviceGroupChannelLanguageLabel(g: any): string {
  const channel = String(g?.channelName || '').trim()
  const lang = languageLabel(g?.language)
  const both = [channel, lang].filter(Boolean).join(' - ')
  if (both) return both

  // fallbacks (during migration)
  const n = String(g?.name || '').trim()
  if (n) return n
  return channel || 'Assigned'
}

export function normalizeDeviceId(src: any): string {
  return String(src?.id ?? src?.alertSourceId ?? src?.sourceId ?? src?.deviceId ?? src?.uid ?? '')
}

export function normalizeDeviceName(src: any): string {
  return String(
    src?.name ??
      src?.label ??
      src?.title ??
      src?.displayName ??
      src?.deviceName ??
      src?.serial ??
      src?.mac ??
      src?.id ??
      'Unknown Device',
  )
}

export function uniqById(devs: Device[]): Device[] {
  const seen: Record<string, boolean> = {}
  const out: Device[] = []
  for (const d of devs) {
    const id = String(d.id || '')
    if (!id) continue
    if (seen[id]) continue
    seen[id] = true
    out.push(d)
  }
  return out
}
